import React, { useState, useEffect } from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import {
  useMatch,
  useResolvedPath,
  Link,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Button, Tooltip } from "@mui/material";
//import logo from "../assets/images/quanti-logo-white.png";
import logo from "../assets/images/sims.svg";
import amgenLogo from "../assets/images/amgen-logo-white.png";
import useAuth from "../hooks/useAuth";
import useSelectedCountry from "../hooks/useSelectedCountry";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";

//Sidebar Icons
import GridViewSharpIcon from "@mui/icons-material/GridViewSharp";
import TuneIcon from "@mui/icons-material/Tune";
import MultilineChartIcon from "@mui/icons-material/MultilineChart";
import ExploreIcon from "@mui/icons-material/Explore";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExitToAppTwoToneIcon from "@mui/icons-material/ExitToAppTwoTone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch } from "react-redux";
import { setState } from "../store/loginSlice";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import useIdleTimeout from "../hooks/useIdleTimeout";
import useTokenValidation from "../hooks/useTokenValidation";

const drawerWidth = 200;
const closedDrawerWidth = 60;
const blue = "#007DC3";
const white = "#FFFFFF";
const blackish = "#303030";
const montserratFont = "Montserrat, sans-serif";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${drawerWidth}px`,
    }),
    ...(!open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${closedDrawerWidth}px`,
    }),
    ...(!open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${closedDrawerWidth}px`,
    }),
  })
);

const appBarTheme = createTheme({
  palette: {
    primary: {
      main: "#fff",
    },
  },
});

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  ...(!open && {
    width: `calc(100% - ${closedDrawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  padding: theme.spacing(0, 0),
  justifyContent: "space-between",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const openedDrawer = (theme) => ({
  width: drawerWidth,
  background: blue,
  color: white,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedDrawer = (theme) => ({
  background: blue,
  color: white,
  width: closedDrawerWidth,
  maxWidth: closedDrawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  background: blue,
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedDrawer(theme),
    "& .MuiDrawer-paper": openedDrawer(theme),
  }),
  ...(!open && {
    ...closedDrawer(theme),
    "& .MuiDrawer-paper": closedDrawer(theme),
  }),
}));

export default function MainLayout() {
  const xyz = useAuth();
  const [open, setOpen] = useState(false);
  const [country, setCountry] = useState("");
  // const { id } = useParams();
  const countries = xyz?.auth?.userCountries;
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  const userFirstName = data.firstName;
  const userLastName = data.lastName;
  const userEmail = data.email;
  const countriesList = data.userCountries;
  const isAdmin = data.isAdmin;
  const { selectedCountry, setSelectedCountry } = useSelectedCountry();
  const menuSelection = {
    dashboard: 0,
    setup: 1,
    analyze: 2,
    define: 3,
    approval: 4,
    filetransfer: 5,
    review: 6,
    functionaladmin: 7,
    admin: 8,
  };

  /* Navigation links */
  const navigationTop = [
    {
      label: "Dashboard",
      route: "/dashboard",
      icon: <GridViewSharpIcon sx={{ color: white }} />,
    },
    {
      label: "Setup",
      route: "/setup",
      icon: <TuneIcon sx={{ color: white }} />,
    },
    {
      label: "Analyze",
      route: "/analyze",
      icon: <MultilineChartIcon sx={{ color: white }} />,
    },
    {
      label: "Define",
      route: "/define",
      icon: <ExploreIcon sx={{ color: white }} />,
    },
    {
      label: "Approval",
      route: "/approval",
      icon: <AssignmentTurnedInIcon sx={{ color: white }} />,
    },
    {
      label: "File Transfer",
      route: "/filetransfer",
      icon: <DriveFileMoveIcon sx={{ color: white }} />,
    },
    {
      label: "Review Order",
      route: "/review",
      icon: <AssignmentIcon sx={{ color: white }} />,
    },
    {
      label: "Functional Admin",
      route: "/functionaladmin",
      icon: <WorkOutlineIcon sx={{ color: white }} />,
    },
    isAdmin
      ? {
          label: "Central Admin",
          route: "/admin",
          icon: <AdminPanelSettingsOutlinedIcon sx={{ color: white }} />,
        }
      : {},
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const currLocation = location.pathname.split("/")[1];

  const CustomNavLink = ({ route, label, icon }) => {
    let resolved = useResolvedPath(route);
    let match = useMatch({ path: resolved.pathname, end: true });

    useEffect(() => {
      setSelectedIndex(menuSelection[currLocation]);
    }, []);

    return (
      <Tooltip
        title={<span style={{ fontSize: 17 }}>{label}</span>}
        placement="right-start"
      >
        {/* <Tooltip
					title={<span style={{ fontSize: 17 }}>{label}</span>}
					placement="right-start"
				> */}
        <ListItemButton
          className="nav-menu-item-wrapper"
          component={Link}
          to={route}
          selected={match ? true : false}
        >
          <ListItemIcon className="nav-menu-item-icon">{icon}</ListItemIcon>
          <ListItemText
            className="nav-menu-item-text"
            primary={label}
            style={{ opacity: open ? 1 : 0 }}
          />
        </ListItemButton>
        {/* </Tooltip> */}
      </Tooltip>
    );
  };

  //const dispatch = useDispatch();
  const handleDrawerOpen = () => {
    setOpen(!open);
    //dispatch(setGlobalState("drawerOpen", !open));
    //dispatch(setState("drawerOpen", !open));
  };

  const handleCountryChange = (e) => {
    //setSelectedCountry(e.target.value);
    const countryName = e.target.value;
    const countryID = countriesList.find(
      (f) => f.country.countryName === countryName
    ).country.countryID;
    dispatch(setState("globalSelectedCountryName", countryName));
    dispatch(setState("globalSelectedCountryID", countryID));
    setCountry(e.target.value);
  };

  const handleListItemClick = (value, index) => {
    setSelectedIndex(index);
  };

  const handlePopperClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopperClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(setState("isLoggedIn", false));
    localStorage.removeItem("data");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  useIdleTimeout(()=>{
    handleLogout();
  },30*60*1000)

  useTokenValidation();

  useEffect(() => {
    let lastActive = parseInt(localStorage.getItem("lastActiveTime"), 10);
    if (!lastActive) {
      localStorage.setItem("lastActiveTime", Date.now().toString());
      lastActive= parseInt(localStorage.getItem("lastActiveTime"), 10);
    }
    const THIRTY_MINUTES = 30 * 60 * 1000;
  
    if (!lastActive || Date.now() - lastActive > THIRTY_MINUTES) {
      handleLogout();
    }
  }, []);  

  const popperOpen = Boolean(anchorEl);
  const popperId = popperOpen ? "simple-popover" : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <ThemeProvider theme={appBarTheme}>
        <AppBar position="fixed" open={open}>
          <Toolbar>
            {/* <img height="40px" src={logo} alt="SIMS" /> */}
            <img src={logo} alt="SiMS" width={110} sx={{ mr: 2 }} />
            <Box
              sx={{
                width: "20%",
                minWidth: 200,
                marginLeft: "30px",
                display: "flex",
                justifyContent: "flex-start",
                marginLeft: "3",
              }}
            >
              {/* <FormControl fullWidth size="small">
								<InputLabel id="demo-simple-select">
									Select Country
								</InputLabel>
								<Select
									labelId="demo-simple-select"
									onChange={handleCountryChange}
									defaultValue={country}
									label="Select Country"
									sx={{ height: 40, width: 300}}
								>
									<MenuItem value="">
										<em>Select Country</em>
									</MenuItem>
									{countriesList.map((obj) => {
										return (
											<MenuItem
												key={obj.country.countryID}
												value={obj.country.countryName}
											>
												{obj.country.countryName}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl> */}
            </Box>
            <Box
              sx={{
                width: "85%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Avatar variant="rounded">
                <AccountCircleIcon
                  sx={{ cursor: "pointer" }}
                  onClick={handlePopperClick}
                />
              </Avatar>
              <Box sx={{ ml: 1 }}>
                <Grid container columns={6} spacing={0}>
                  <Grid item sm={6}>
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: blue,
                        fontFamily: montserratFont,
                      }}
                    >
                      Hi {userFirstName}
                    </Typography>
                  </Grid>
                  <Grid item sm={6}>
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: blackish,
                        fontFamily: montserratFont,
                      }}
                    >
                      {userEmail}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Popover
                id={popperId}
                open={popperOpen}
                anchorEl={anchorEl}
                onClose={handlePopperClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                sx={{ height: "180px" }}
              >
                <Box sx={{ height: 180, width: 250 }}>
                  <Box sx={{ height: 100, background: "steelblue" }}>
                    <Grid
                      container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Grid item sx={{ height: 0, mt: 2, mb: 1 }} sm={12}>
                        <AccountCircleIcon
                          style={{ fontSize: 30 }}
                          size="large"
                          sx={{ color: "white" }}
                        />
                      </Grid>
                      <Grid item sm={12}>
                        <Typography
                          sx={{
                            fontSize: 12,
                            color: "white",
                            fontFamily: montserratFont,
                          }}
                        >
                          {userEmail}
                        </Typography>
                      </Grid>
                      {/* <Grid item sm={12}>
												<Typography
													sx={{
														fontSize: 12,
														color: "white",
														fontFamily: montserratFont,
													}}
												>
													IQVIA ©
												</Typography>
											</Grid> */}
                    </Grid>
                  </Box>
                  <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    columns={12}
                    height={"10px"}
                  >
                    {/* <Grid item sm={4}>
                      <CustomNavLink
                        route={"/login"}
                        label={"Logout"}
                        icon={<ExitToAppTwoToneIcon />}
                      />
                    </Grid> */}
                    <Grid item sm={4}>
                      <ListItemButton className="nav-menu-item-wrapper">
                        <ListItemIcon className="nav-menu-item-icon">
                          <ExitToAppTwoToneIcon onClick={handleLogout} />
                        </ListItemIcon>
                      </ListItemButton>
                    </Grid>
                    <Grid
                      item
                      sm={7}
                      sx={{
                        height: "10px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 12,
                          color: "black",
                          fontFamily: montserratFont,
                          fontWeight: 500,
                          mt: -0.5,
                        }}
                      >
                        Logout
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Popover>
            </Box>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{ ml: 3 }}>
          {open ? <img src={amgenLogo} alt="Amgen-Logo" width={150} /> : ""}
        </DrawerHeader>
        <ThemeProvider theme={appBarTheme}>
          <List disableadding sx={{ mt: 5 }}>
            {navigationTop.map((item, index) => (
              <ListItem
                key={item.label}
                variant="contained"
                button
                disablePadding
                style={{ display: "block" }}
                selected={selectedIndex === index}
                onClick={() => handleListItemClick(item.label, index)}
              >
                <CustomNavLink
                  route={item.route}
                  label={item.label}
                  icon={item.icon}
                />
              </ListItem>
            ))}

            <ListItem
              button
              variant="contained"
              key="openMenu"
              disablePadding
              style={{ display: "block", marginTop: 1 }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: "normal",
                  pl: 1.5,
                }}
                onClick={handleDrawerOpen}
              >
                <ListItemIcon sx={{ minWidth: 0, justifyContent: "normal" }}>
                  <MenuIcon
                    sx={{
                      color: white,
                      ...(open && {}),
                    }}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </ThemeProvider>
      </Drawer>
      <Main open={open} sx={{ pl: 0, ml: 2, width: "95%" }}>
        <DrawerHeader />
        <Outlet />
      </Main>
    </Box>
  );
}
